import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoaderService } from 'src/app/common/loader/loader.service';
import { Data2Service } from 'src/app/common/data2.service';
import { DateService } from 'src/app/common/date.service';
import { DataBagService } from './data-bag.service';

@Component({
	selector: 'app-calendar',
	template: '',
})
export class CalendarComponent implements OnInit, OnDestroy {
	date_from: string;
	date_to: string;
	module: string;
	filters: any;
	protected routeSubscribe;

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected date: DateService,
		protected loader: LoaderService,
		protected route: ActivatedRoute,
		protected router: Router,
	) {}

	ngOnInit(): void {
		if (!this.route.snapshot.params['date']) {
			this.router.navigate([
				this.route.snapshot.url[0].path,
				!this.getSelectedDate() ? this.date.now().date : this.getSelectedDate(),
			]);
			return;
		}
		this.routeSubscribe = this.route.params.subscribe((parms) => {
			if (!parms.date) {
				return;
			}
			this.date_from = parms.date;
			this.date_to = this.date.daysAdd(+14, parms.date);
			this.loadData();
		});
		this.loader.show();
		this.loadAdditionalData();
	}

	ngOnDestroy(): void {
		if (this.routeSubscribe) {
			this.routeSubscribe.unsubscribe();
		}
	}

	private getSelectedDate() {
		if (!localStorage['pageSettings-' + this.module]) {
			return;
		}
		return JSON.parse(localStorage['pageSettings-' + this.module]).calendarDate;
	}

	protected loadAdditionalData(): void {}

	protected loadData(): void {}

	eventClosed(event): void {}

	filtersSelected(data) {
		this.filters = data;
		this.loadData();
	}
}
